// 4.2. Data Models > 4.2.1. account.business > 4.2.1.1. Constants
// https://confluence.shopee.io/pages/viewpage.action?spaceKey=SAUT&title=%5BTD%5D%5BDraft%5D+ToB+Account+-+account.business#heading-4211Constants
import {
  _object,
  _optional,
  _number,
  _string,
  _enum,
  TypeOf,
} from '@shopee-user/schema-formatter';

import { BusinessIdType } from '@shopee-user/global';
import { LinkStatus } from '@shopee-user/business-customization-types';

export enum BusinessAccountRole {
  Pending = 0,
  Admin = 1,
  Staff = 2,
}

export enum BusinessAccountStatus {
  Deleted = 0,
  Normal = 1,
  Banned = 2,
}

// 4.2. Data Models > 4.2.1. account.business > 4.2.1.4. BusinessAccount
// https://confluence.shopee.io/pages/viewpage.action?spaceKey=SAUT&title=%5BTD%5D%5BDraft%5D+ToB+Account+-+account.business#heading-4214BusinessAccount

export const businessAccountSchema = _object({
  userid: _optional(_number),
  // ToB One Credential User ID
  cred_userid: _optional(_number),
  business_id: _optional(_enum(BusinessIdType)),
  role: _optional(_enum(BusinessAccountRole)),
  username: _optional(_string), // if migrated to one credential, will be ToC username
  staff_name: _optional(_string), // (only for one credential) This stores the ToB username.
  phone: _optional(_string), // if migrated to one credential, will be ToC phone
  email: _optional(_string), // if migrated to one credential, will be ToC email
  password: _optional(_string), // will be masked as ******** if exists
  region: _optional(_string),
  status: _optional(_enum(BusinessAccountStatus)),
  create_time: _optional(_number),
  update_time: _optional(_number),
  last_update_phone_time: _optional(_number),
  last_update_password_time: _optional(_number),
  last_update_email_time: _optional(_number),
  last_update_status_time: _optional(_number),
  last_update_username_time: _optional(_number),
  portrait: _optional(_string), // only exists for accounts migrated to one credential. This is ToC portrait
  toc_userid: _optional(_number), // only exists for login_by_shopee API
  link_status: _optional(_enum(LinkStatus)), // only exists for login_by_shopee API
});
export type BusinessAccount = TypeOf<typeof businessAccountSchema>;

export type BusinessAccountResponse = {
  account?: BusinessAccount;
  nonce: string;
  error_msg?: string;
};
